import { Reveal } from "./Reveal";
import { SectionHeading } from "./SectionHeading";

const STEPS = [
    {
        title: "Discuție de potrivire",
        text: "Gratuită, maximum 15 minute: localizare, situație, calendar și limite. Nu promitem nimic până nu verificăm că putem ajuta cu adevărat.",
    },
    {
        title: "Pachetul convenit",
        text: "Alegem împreună pachetul potrivit și îl punem în scris: sarcini, ore, intervale, costuri și anulări — clar, fără surprize.",
    },
    {
        title: "Planul pe o pagină",
        text: "Ce trebuie pregătit, cine face fiecare lucru, până când și cât costă. Întrebările medicale devin întrebări pentru medic, nu presupuneri.",
    },
    {
        title: "Confirmări de la furnizori",
        text: "Echipament disponibil, transport compatibil cu accesul, oră și cost confirmat. Noi urmărim fiecare confirmare, tu auzi doar rezultatul.",
    },
    {
        title: "Revenire în 24–48 de ore",
        text: "După sosirea acasă, revenim în intervalul convenit pentru problemele practice. Nevoile clinice ajung direct la profesionistul competent.",
    },
];

export const Steps = () => (
    <section id="cum-functioneaza" data-testid="steps-section" className="bg-sand/50 py-16 sm:py-24 lg:py-32">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <div className="grid grid-cols-1 gap-12 lg:grid-cols-12 lg:gap-16">
                <div className="lg:col-span-5">
                    <div className="lg:sticky lg:top-32">
                        <SectionHeading
                            testid="steps-heading"
                            eyebrow="Cum funcționează"
                            title="De la primul apel la prima săptămână"
                            text="Un parcurs simplu, cu pași clari și responsabilități explicite — ca familia să vadă rezultatul: casa pregătită, transportul confirmat, programul cunoscut."
                        />
                    </div>
                </div>
                <ol className="lg:col-span-7 relative flex flex-col gap-8 before:absolute before:left-[27px] before:top-4 before:bottom-4 before:w-px before:bg-teal/15">
                    {STEPS.map((step, i) => (
                        <Reveal key={step.title} delay={i * 0.06}>
                            <li className="relative flex gap-5 sm:gap-7" data-testid={`step-item-${i + 1}`}>
                                <span className="relative z-10 flex h-14 w-14 shrink-0 items-center justify-center rounded-full bg-teal font-mono text-sm font-medium text-cream ring-8 ring-sand/0">
                                    0{i + 1}
                                </span>
                                <div className="rounded-3xl bg-creamlight p-6 sm:p-7 ring-1 ring-teal/10 flex-1">
                                    <h3 className="font-serif text-xl sm:text-2xl font-semibold text-charcoal">{step.title}</h3>
                                    <p className="mt-2 text-sm sm:text-base text-charcoal/70 leading-relaxed">{step.text}</p>
                                </div>
                            </li>
                        </Reveal>
                    ))}
                </ol>
            </div>
        </div>
    </section>
);
